import { combineReducers } from 'redux'
import theme from './themeStore'
import authen from './authenStore'
import stddashboard from './studentDashboardStore'
import enroll from './enrollStore'
import enrollType from './enrollTypeStore'
import installmentType from './installmentTypeStore'
import finStd from './financeStudentStore'
import calendar from './calendar'
import preRegister from './preRegisterStore'
import stdProfile from './profileStore'
import notifications from './notificationStore'
import transferEnroll from './transferEnrollStore'
import advisorAnnouncement from './advisorAnnouncementStore'
import curriculum from './curriculumReducer'
import routes from './routeStore'
import graduateReq from './graduateReqStore'
import graduateSearchFilter from './graduateSearchFilterStore'

export default combineReducers({
  theme,
  authen,
  stddashboard,
  enroll,
  enrollType,
  installmentType,
  finStd,
  calendar,
  preRegister,
  stdProfile,
  notifications,
  transferEnroll,
  routes,
  advisorAnnouncement,
  graduateReq,
  graduateSearchFilter,
  curriculum,
})
